export default "__VITE_ASSET__DJSuvbJ5__"